import { createActions, handleActions } from 'redux-actions'
import Immutable, { List, Map } from 'immutable'
import fetch from '@request/fetch'

const GROUPS_SEARCH = 'GROUPS_SEARCH' // 词库列表获取

const GROUP_WORDS_SEARCH = 'GROUP_WORDS_SEARCH' // 词库中文本列表获取

const GROUP_GET = 'GROUP_GET' // 获取词库信息

const GROUP_ADD = 'GROUP_ADD' // 增加词库

const GROUP_UPDATE = 'GROUP_UPDATE' // 更新词库

const GROUP_DELETE = 'GROUP_DELETE' // 删除词库

const GROUP_STATUS = 'GROUP_STATUS' // 修改词库状态

const WORD_DELETE = 'WORD_DELETE' // 删除黑词

const WORD_TYPE_SEARCH = 'WORD_TYPE_SEARCH' // 获取黑词类别 —— 搜索

const CHECKBOX_WORD_TYPE_SEARCH = 'CHECKBOX_WORD_TYPE_SEARCH' // 获取黑词类别 —— 打标


const WORDS_ADD = 'WORDS_ADD' // 批量新增黑词

const defaultState = Immutable.fromJS({
  groups: {
    list: [],
    total: 0
  },
  words: {
    list: [],
    total: 0
  },
  wordTypes: [],
  checkBoxWordTypes: [] // 打标的内容标记用checkBoxWordTypes，搜索的用wordTypes
})

export const blackwordAction = createActions({
  GROUPS_SEARCH: async params => {
    const result = await fetch.post(`/blackword/searchGroups`, params)
    return result
  },
  GROUP_GET: async params => {
    const result = await fetch.post(`/blackword/getGroup`, params)
    return result
  },
  GROUP_WORDS_SEARCH: async params => {
    const result = await fetch.post(`/blackword/searchWords`, params)
    return result
  },
  GROUP_ADD: async params => {
    const result = await fetch.post(`/blackword/postGroup`, params)
    return result
  },
  GROUP_UPDATE: async params => {
    const result = await fetch.post(`/blackword/patchGroup`, params)
    return result
  },
  GROUP_DELETE: async params => {
    const result = await fetch.post(`/blackword/deleteGroup`, params)
    return result
  },
  GROUP_STATUS: async params => {
    const result = await fetch.post(`/blackword/patchGroupStatus`, params)
    return result
  },
  WORD_DELETE: async params => {
    const result = await fetch.post(`/blackword/deleteWord`, params)
    return result
  },
  WORD_TYPE_SEARCH: async () => {
    const result = await fetch.post(`/violation/searchType`)
    return result
  },
  CHECKBOX_WORD_TYPE_SEARCH: async () => {
    const result = await fetch.post(`/violation/searchRealType`)
    return result
  },
  WORDS_ADD: async params => {
    const result = await fetch.post(`/blackword/postWords`, params)
    return result
  },
  WORDS_IS_WHITE: async params => {
    const result = await fetch.post(`/blackword/wordIsWhite`, params)
    return result
  }
})

const reducer = handleActions(
  {
    [GROUPS_SEARCH]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'groups',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    },
    [GROUP_WORDS_SEARCH]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'words',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    },
    [WORD_TYPE_SEARCH]: (state, action) => {
      let curState = state
      const data = action.payload
      curState = curState.set(
        'wordTypes',
        new List(data)
      )
      return curState
    },
    [CHECKBOX_WORD_TYPE_SEARCH]: (state, action) => {
      let curState = state
      const data = action.payload
      curState = curState.set(
        'checkboxWordTypes',
        new List(data)
      )
      return curState
    }
  },
  defaultState
)

export default reducer
